import { useApi } from './useApi';
import { apiService, getCurrentLocale } from '../services/api';

interface FeatureItem {
  id: number;
  icon: 'safe' | 'caduceus' | 'injection';
  title: string;
  description: string;
}

interface WhyChooseSectionData {
  id: number;
  documentId: string;
  title: string;
  subtitle?: string;
  features: FeatureItem[];
  backgroundColor?: string;
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
}

export function useWhyChooseSection() {
  const locale = typeof window !== 'undefined' ? getCurrentLocale() : 'nl';
  return useApi<WhyChooseSectionData>(apiService.getWhyChooseSection, [locale]);
}